import PageShell, { SectionLabel } from "@/components/PageShell";

export default function LegalPage({ testId, index, label, title, updated, sections }) {
  return (
    <PageShell testId={testId}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 py-16 md:py-24">
          <div className="md:col-span-4">
            <SectionLabel index={index}>{label}</SectionLabel>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500 mt-8">
              Last updated
            </p>
            <p className="font-mono text-sm text-white mt-1">{updated}</p>
          </div>
          <div className="md:col-span-8">
            <h1 className="font-display text-5xl md:text-6xl lg:text-7xl text-white leading-[1.02] tracking-tight">
              {title}
            </h1>
          </div>
        </div>

        <div className="border-t border-white/5 pt-12 pb-24 grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-8 md:col-start-4 space-y-12">
            {sections.map((s, i) => (
              <section key={s.h}>
                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#CCFF00] mb-3">
                  §{String(i + 1).padStart(2, "0")}
                </p>
                <h2 className="font-display text-2xl md:text-3xl text-white mb-4">{s.h}</h2>
                {s.body.map((p, j) => (
                  <p key={j} className="text-zinc-400 leading-relaxed mb-4">
                    {p}
                  </p>
                ))}
              </section>
            ))}

            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-600 pt-8 border-t border-white/5">
              Questions? Reach us at contact@imaginepedia.tech
            </p>
          </div>
        </div>
      </div>
    </PageShell>
  );
}
